import React, {useState, useEffect} from 'react';
import './style.css';
import { ToggleBar } from '../../components/toggleBar/toggleBar';
import { DashboardTile } from '../dashboardTile/dashboardTile';
import CampaignSelector from '../../components/toggleBar/toggleBarOptions';
import { DashboardMiniTable } from './dashboardMiniTable';
import { DashboardMetricDisplayLarge } from './dashboardDisplayLarge';
import { DashboardTogglebar } from './dashboardToggleBar';
import { Graph } from '../graph/graph';


/*
Pass in data:
- dashboard ID (pull from firestore)

Data Response Format (setting any of these to None will make field not display):
- id: str
- dashboard_label: str
- total_ct: int
- total_label: str
= filters: list (add all by default when set)
- metrics: dict
    - name: str
    - total_ct: int
    - total_pct: float,
    - time_series: list
        - timestamp: datetime
        - value: float
*/


const DashboardWidget = ({flowType }) => {
    const [select_value, setSelectValue] = useState("ALL");
    const [visibleMetrics, setVisibleMetrics] = useState([]);
    const [mini_table_values, setMiniTableValues] = useState([]);
    const [graph_data, setGraphData] = useState({})
    const [dashboardData, setDashboardData] = useState({
        id: "12345",
        label: "Campaign Metrics",
        total_ct: 12345,
        total_label: "Deliveries",
        filters: [
            {label: "All Campaigns", value: "ALL"},
            {label: "Washington Bros", value: "efe029a6054f4996afe9710e942817c8"}
        ],
        metrics: [
            {
                name: "Opens",
                total_ct: 30,
                total_pct: 0.15,
                timeseries: [
                    {
                        timestamp: "3/10",
                        value: 0.1
                    },
                    {
                        timestamp: "3/11",
                        value: 0.2
                    },
                    {
                        timestamp: "3/12",
                        value: 0.1
                    },
                    {
                        timestamp: "3/13",
                        value: 0.3
                    },
                    {
                        timestamp: "3/14",
                        value: 0.5
                    }
                ]
            },
            {
                name: "Clicks",
                total_ct: 12,
                total_pct: 0.05,
                timeseries: [
                    {
                        timestamp: "3/10",
                        value: 0.01
                    },
                    {
                        timestamp: "3/11",
                        value: 0.02
                    },
                    {
                        timestamp: "3/12",
                        value: 0.01
                    },
                    {
                        timestamp: "3/13",
                        value: 0.03
                    },
                    {
                        timestamp: "3/14",
                        value: 0.05
                    }
                ]
            },
            {
                name: "Bounces",
                total_ct: 2,
                total_pct: 0.01,
                timeseries: [
                    {
                        timestamp: "3/10",
                        value: 0.001
                    },
                    {
                        timestamp: "3/11",
                        value: 0.2
                    },
                    {
                        timestamp: "3/12",
                        value: 0.001
                    },
                    {
                        timestamp: "3/13",
                        value: 0.003
                    },
                    {
                        timestamp: "3/14",
                        value: 0.005
                    }
                ]
            }
        ]
    });

    // const testMetricData = [
    //     {
    //         colorClass: "green",
    //         name: "Opens",
    //         count: "30",
    //         percentage: "15%"
    //     },
    //     {
    //         colorClass: "red",
    //         name: "Clicks",
    //         count: "12",
    //         percentage: "5%"
    //     },
    //     {
    //         colorClass: "blue",
    //         name: "Bounces",
    //         count: "2",
    //         percentage: "1%"
    //     },
    // ];

    const dashboardToggleSelect = (value) => {
        console.log(value);
        setSelectValue(value);

        // TODO: Pull filtered campaign data from backend
        // set dashboardData
    };

    const setMiniTableFromMetricsData = (metrics_data) => {
        const formattedMetrics = metrics_data.map(metric => ({
            colorClass: getColorForMetric(metric.name),
            name: metric.name,
            count: metric.total_ct.toString(),
            percentage: `${(metric.total_pct * 100).toFixed(2)}%`
        }));
        setMiniTableValues(formattedMetrics);
    };

    const setGraphFromMetricsData = (metrics_data) => {
        const graphData = {};
        metrics_data.forEach(metric => {
            graphData[metric.name] = {
                data: metric.timeseries.map(entry => ({
                    timestamp: entry.timestamp,
                    value: (entry.value * 100).toFixed(2)
                })),
                color: getColorForMetric(metric.name)
            };
        });
        setGraphData(graphData);
    };

    const toggleMetric = (metricName) => {
        setVisibleMetrics((prev) =>
            prev.includes(metricName)
                ? prev.filter((m) => m !== metricName)
                : [...prev, metricName]
        );
    };

    useEffect(() => {
        if (dashboardData?.metrics) {
            setMiniTableFromMetricsData(dashboardData.metrics);
            setGraphFromMetricsData(dashboardData.metrics);
            setVisibleMetrics(dashboardData.metrics.map(metric => metric.name));
        }
    }, []);

    const getColorForMetric = (metricName) => {
        const colorMapping = {
            Opens: "green",
            Clicks: "red",
            Bounces: "blue"
        };
        return colorMapping[metricName] || "gray";
    };

    return (
        <div className='dashboard-widget-container'>
            <div className='heading-container'> 
                {dashboardData?.label}
            </div>
            <div className='dashboard-metric-container'>
                <div className='non-graph-container'>
                    <div className='metrics-card-container'> 
                        <DashboardTogglebar options={dashboardData?.filters} onSelectAction={dashboardToggleSelect} />
                        <DashboardMetricDisplayLarge value={dashboardData?.total_ct} subtext={dashboardData?.total_label} />
                        <DashboardMiniTable dashboardMetrics={mini_table_values} visibleMetrics={visibleMetrics} toggleMetric={toggleMetric} />
                    </div>
                </div>

                <div className='graph-container'>
                    <Graph dataset={graph_data} showLegend={false} visibleMetrics={visibleMetrics} />
                </div>
            </div>
        </div>
    );
};

export { DashboardWidget };
